
import { Options, setup, Vue } from 'vue-class-component';
import { useRouter } from "vue-router";

@Options({})
export default class NotFound extends Vue {

  routeInfo = setup(()=>{
    const router = useRouter();
    const back = ()=>{
      router.back();
    }
    return {
      back
    }
  })
}
